<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oPFysS/tc-custom/9781453268162.jpg?1704318389378" alt="This image is the cover for the book Handknit Holidays"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Handknit Holidays
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Knitting in America</i> offers more than 50 winter knitting projects—from classic holiday decorations to stylishly original gifts.</b><br/><br/> For many people, the best part of the winter holidays is the anticipation: planning the perfect gifts, decorating the house, looking forward to seeing family and friends. Holidays can be particularly special for knitters, whose preparations often start months in advance and involve their own creations. In <i>Handknit Holidays</i> best-selling knitting author Melanie Falick presents an eclectic collection of more than 50 original gifts, decorations, and clothing pieces for Christmas, Hanukkah, and the winter solstice, providing year-round inspiration for knitters of all levels.<br/><br/> Created by top knitwear designers, the projects include colorful ornaments; funky and classic Christmas stockings; a wire-and-bead menorah; sparkly ribbon scarves; a poncho and matching dog sweater; and a range of super-quick projects for that last-minute holiday rush, from a Santa hat, to elf caps, to flower pins. Rounding out the volume are a few grand projects—an Aran tree skirt, a patchwork afghan, a lace shawl—destined to become family heirlooms, plus features on such topics as the origin of the Christmas stocking, the meaning of the winter solstice, knitting for charities, strategies for finishing holiday knitting (on schedule!), and even a delicious recipe for festive crescent cookies.<br/><br/> Beautifully photographed by Susan Pittard, <i>Handknit Holidays </i>is a creative celebration of the holiday season and a treasure for all knitters who seek to bring more of their own handwork—and artistry—into their daily lives and their holiday festivities.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melanie Falick, Susan Pittard
      </h2>
      
      <p class="authorDescription body article">Melanie Falick, editorial director of STC Craft, is the author of <I>Handknit Holidays</I>,<I> Knit: A Personal Handbook</I>, and <I>Knitting for Baby</I> (with Kristin Nicholas) (all STC), plus <I>Kids Knitting</I> and <I>Knitting in America</I>&mdash;with more than 400,000 books in print. She lives in Dutchess County, NY.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stewart, Tabori and Chang An imprint of ABRAMS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7288204c